import { render, staticRenderFns } from "./alertWithChoose.vue?vue&type=template&id=18bc3005&scoped=true"
import script from "./alertWithChoose.vue?vue&type=script&lang=js"
export * from "./alertWithChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc3005",
  null
  
)

export default component.exports